import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { IconComponent } from '../icons/icon/icon.component';
import { Icon } from '../icons/icon/svg-cache.service';

@Component({
  selector: 'ui-section-header',
  templateUrl: './section-header.component.html',
  styleUrl: './section-header.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonComponent],
})
export class SectionHeaderComponent {
  readonly icon = input<Icon>();
  readonly headline = input.required<string>();
  readonly subtext = input<string>();

  readonly primaryAction = input<{ label: string; onClick: () => void; loading?: boolean; disabled?: boolean }>();
  readonly secondaryAction = input<{ label: string; onClick: () => void; loading?: boolean; disabled?: boolean }>();
  readonly learnMoreOptions = input<{ label: string; href: string }[]>();

  readonly hasActions = computed(() => !!(this.primaryAction() || this.secondaryAction()));
}
